import { defineComponent as d, computed as o, openBlock as i, createElementBlock as r, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as f, createStaticVNode as _ } from "vue";
const m = ["viewBox"], p = /* @__PURE__ */ t("mask", { id: "a89dd552-cc03-4304-a4a2-70467e60a773" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#a89dd552-cc03-4304-a4a2-70467e60a773)" }, u = { key: 0 }, v = /* @__PURE__ */ _('<path fill="#d80027" d="M0 256 256 0h256v512H0z"></path><path fill="#0052b4" d="M256 256V0H0v256z"></path><path fill="#eee" d="m222.6 149.8-31.3 14.7 16.7 30.3-34-6.5-4.3 34.3-23.6-25.2-23.7 25.2-4.3-34.3-34 6.5 16.7-30.3-31.2-14.7 31.2-14.7-16.6-30.3 34 6.5 4.2-34.3 23.7 25.3L169.7 77l4.3 34.3 34-6.5-16.7 30.3z"></path><circle cx="146.1" cy="149.8" r="47.7" fill="#0052b4"></circle><circle cx="146.1" cy="149.8" r="41.5" fill="#eee"></circle>', 5), g = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ d({
  __name: "tw",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const e = a, l = o(() => 512 + 2 * e.strokeWidth), c = o(() => -e.strokeWidth), s = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${l.value} ${l.value}`
    }, [
      p,
      t("g", k, [
        e.flagName ? (i(), r("title", u, n(e.flagName), 1)) : h("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: s.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  W as default
};
//# sourceMappingURL=tw-eae8c0a7.js.map
